import { render, staticRenderFns } from "./PreferredName.vue?vue&type=template&id=ef158260"
import script from "./PreferredName.vue?vue&type=script&lang=js"
export * from "./PreferredName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports